import React from 'react';
import { Select as AntdSelect } from 'antd';
import type { SelectProps as AntdSelectProps } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import { resolvePopupContainer } from '../_internal/portalContainer';
import './Select.css';

export interface WxbSelectProps extends AntdSelectProps {
  label?: string;
  error?: string;
}

export const WxbSelect: React.FC<WxbSelectProps> = ({
  label,
  error,
  className = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  // 全屏下下拉就近渲染到触发器内,避免 portal 到 body 跑出全屏;非全屏保持 antd 默认(body)。
  getPopupContainer = resolvePopupContainer,
  ...props
}) => {
  const { controlId, feedbackId } = useWxbFieldIds(id);
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
      <AntdSelect
        {...props}
        id={controlId}
        className={`wxb-select ${error ? 'wxb-select-error' : ''} ${className}`}
        popupClassName="wxb-select-popup"
        getPopupContainer={getPopupContainer}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
        status={error ? 'error' : props.status}
      />
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
